document.querySelectorAll('.subscription-selector').forEach(function(container) {
  var currentMode = container.getAttribute('data-default-mode') === 'otp' ? 'otp' : 'subscribe';
  var sectionId = container.getAttribute('data-section-id');
  var productId = container.getAttribute('data-product-id');
  var productFormId = container.getAttribute('data-product-form-id');

  var sellingPlanInput = container.querySelector('.subscription-selector__input');
  var otpOption = container.querySelector('[data-option="otp"]');
  var subscribeOption = container.querySelector('[data-option="subscribe"]');
  var frequencyButtons = container.querySelectorAll('.subscription-selector__freq-btn');
  var dataEl = container.querySelector('[data-subscription-data]');
  var data = {};
  if (dataEl) {
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('[subscription-selector] JSON parse error:', e, dataEl.textContent);
    }
  }
  var currentPlanId = data.defaultPlanId;

  function getCurrentVariantId() {
    var form = document.getElementById(productFormId);
    if (!form) return null;
    var input = form.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  function formatMoney(cents) {
    if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function selectMode(mode) {
    currentMode = mode;

    var otpRadio = otpOption.querySelector('.subscription-selector__radio');
    var subRadio = subscribeOption.querySelector('.subscription-selector__radio');

    if (mode === 'otp') {
      otpOption.classList.add('subscription-selector__option--active');
      subscribeOption.classList.remove('subscription-selector__option--active');
      otpRadio.classList.add('subscription-selector__radio--checked');
      subRadio.classList.remove('subscription-selector__radio--checked');
      sellingPlanInput.value = '';
      sellingPlanInput.removeAttribute('name');
    } else {
      subscribeOption.classList.add('subscription-selector__option--active');
      otpOption.classList.remove('subscription-selector__option--active');
      subRadio.classList.add('subscription-selector__radio--checked');
      otpRadio.classList.remove('subscription-selector__radio--checked');
      sellingPlanInput.setAttribute('name', 'selling_plan');
      sellingPlanInput.value = currentPlanId;
    }

    updatePriceDisplays();
  }

  function selectFrequency(btn) {
    frequencyButtons.forEach(function(b) { b.classList.remove('subscription-selector__freq-btn--active'); });
    btn.classList.add('subscription-selector__freq-btn--active');
    currentPlanId = btn.getAttribute('data-selling-plan-id');
    sellingPlanInput.value = currentPlanId;

    if (currentMode !== 'subscribe') {
      selectMode('subscribe');
    }

    updateSubscribePriceUI();
    updatePriceDisplays();
  }

  function updateSubscribePriceUI() {
    var variantId = getCurrentVariantId();
    if (!data.variants) return;
    var variantData = data.variants[variantId];
    if (!variantData) return;

    var planData = variantData.plans[currentPlanId];
    if (!planData) return;

    var pricesEl = container.querySelector('[data-subscribe-prices]');
    if (!pricesEl) return;

    var html = '<span class="subscription-selector__price--current">' + formatMoney(planData.price) + '</span>';
    if (planData.compareAtPrice > planData.price) {
      html += '<span class="subscription-selector__price--compare">' + formatMoney(planData.compareAtPrice) + '</span>';
    }
    pricesEl.innerHTML = html;
  }

  function updatePriceDisplays() {
    var variantId = getCurrentVariantId();
    if (!data.variants) return;
    var variantData = data.variants[variantId];
    if (!variantData) return;

    var priceIds = ['Price', 'BuyButtonPrice', 'StickyPrice'];

    if (currentMode === 'subscribe') {
      var planData = variantData.plans[currentPlanId];
      if (!planData) return;

      priceIds.forEach(function(prefix) {
        var el = document.querySelector('#' + prefix + '-' + sectionId + '-' + productId);
        if (!el) return;

        var priceContainer = el.querySelector('.price') || el;

        if (planData.compareAtPrice > planData.price) {
          priceContainer.classList.add('price--on-sale');
          priceContainer.innerHTML = '<span class="price__sale inline-flex items-center h-auto relative">' + formatMoney(planData.compareAtPrice) + '</span>' +
            '<span class="price__regular whitespace-nowrap">' + formatMoney(planData.price) + '</span>';
        } else {
          priceContainer.classList.remove('price--on-sale');
          priceContainer.innerHTML = '<span class="price__regular whitespace-nowrap">' + formatMoney(planData.price) + '</span>';
        }
      });
    } else {
      priceIds.forEach(function(prefix) {
        var el = document.querySelector('#' + prefix + '-' + sectionId + '-' + productId);
        if (!el) return;

        var priceContainer = el.querySelector('.price') || el;
        priceContainer.classList.remove('price--on-sale');
        priceContainer.innerHTML = '<span class="price__regular whitespace-nowrap">' + formatMoney(variantData.price) + '</span>';
      });
    }
  }

  // Bind click handlers
  if (otpOption) {
    otpOption.addEventListener('click', function() {
      selectMode('otp');
    });
  }

  if (subscribeOption) {
    subscribeOption.addEventListener('click', function(e) {
      if (e.target.closest('.subscription-selector__freq-btn')) return;
      selectMode('subscribe');
    });
  }

  frequencyButtons.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      selectFrequency(btn);
    });
  });

  // Listen for variant changes
  if (typeof theme !== 'undefined' && theme.pubsub && theme.pubsub.subscribe) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function(event) {
      var eventData = event.data;
      if (eventData.sectionId !== sectionId) return;

      var variantId = eventData.variant ? eventData.variant.id : null;
      if (!variantId) return;

      if (!data.variants) return;
      var variantData = data.variants[variantId];
      if (!variantData) return;

      var otpPriceEl = container.querySelector('[data-otp-price]');
      if (otpPriceEl) {
        otpPriceEl.textContent = formatMoney(variantData.price);
      }

      updateSubscribePriceUI();
      setTimeout(function() { updatePriceDisplays(); }, 50);
    });
  }

  // Apply the configured pricing on load.
  updatePriceDisplays();
});
